/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */

if (!customElements.get("product-media")) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        slider: "[data-slider]",
        thumbs: "[data-thumbs]",
        mediaItem: "[data-media-id]",
      };
      this.selectedMediaIndex =
        Number(
          this.querySelector(this.selectors.slider)?.querySelector(
            "[data-selected]"
          )?.dataset.index
        ) || 0;
      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            initialSlide: this.selectedMediaIndex,
            watchOverflow: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              type: 'bullets',
            },
            navigation: {
              prevEl: this.querySelector(".swiper-arrow--prev"),
              nextEl: this.querySelector(".swiper-arrow--next"),
            },
          },
        },
      };
    }

    connectedCallback() {
      this.init();
    }

    pauseAllMedia(element = document) {
      element.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      });
      element.querySelectorAll("video").forEach((video) => video.pause());
    }

    init() {
      if (!this.settings.elements.slider) return;

      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider
      );

      this.settings.instances.slider.on("slideChange", () => {
        this.pauseAllMedia();
        let active = this.querySelector(".swiper-slide-next");
        if (!active) return console.log("no active slide");
        active.querySelectorAll("video").forEach((video) => {
          video.play();
        });
      });
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(
        this.querySelectorAll(this.selectors.mediaItem)
      )?.find((media) => Number(media.dataset.mediaId) === id);
      if (!mediaFound) return;
      this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
    }
  }

  customElements.define("product-media", ProductMedia);
}
